import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionStepEnum } from 'src/app/model/analize-step-history';
import {
  AnalysisStatusEnum,
  DebtTypeEnum,
  FiscalYearEnum,
  InfoInputValueEnum,
  PlantingAreaEnum,
  RatingEnum,
  StepAnalyseEnum,
  TypeAnalyseEnum,
  TypeDeliveryEnum,
} from 'src/app/model/analyse-credit';
import { AuditTypeEnum } from 'src/app/model/audit';
import { TypePermissionEnum } from 'src/app/model/user';

@Injectable({ providedIn: 'root' })
export class UtilsService {
  public static TypePermissionUser: Array<IdNumberAndDescription> = [
    { id: TypePermissionEnum.ANALISTA, description: 'Analista' },
    {
      id: TypePermissionEnum.GERENTE_ADMINISTRATIVO,
      description: 'Gerente Administrativo',
    },
    { id: TypePermissionEnum.GERENTE_LOJA, description: 'Gerente Loja' },
    { id: TypePermissionEnum.CORPORATIVO, description: 'Corporativo' },
    {
      id: TypePermissionEnum.DIRETOR_COMERCIAL,
      description: 'Diretor Administrativo',
    },
    {
      id: TypePermissionEnum.DIRETOR_PRESIDENTE,
      description: 'Diretor Presidente',
    },
    { id: TypePermissionEnum.VISUALIZAR, description: 'Visualizar' },
  ];

  public static StepAnalyseEnums: Array<IdNumberAndDescription> = [
    {
      id: StepAnalyseEnum.GERENTE_ADMINISTRATIVO,
      description: 'Gerente Administrativo',
    },
    { id: StepAnalyseEnum.GERENTE_LOJA, description: 'Gerente Loja' },
    { id: StepAnalyseEnum.CORPORATIVO, description: 'Corporativo' },
    {
      id: StepAnalyseEnum.DIRETOR_COMERCIAL,
      description: 'Diretor Administrativo',
    },
    {
      id: StepAnalyseEnum.DIRETOR_PRESIDENTE,
      description: 'Diretor Presidente',
    },
  ];

  public static PlantingAreaEnums: Array<IdNumberAndDescription> = [
    { id: PlantingAreaEnum.OWN, description: 'Proprio' },
    { id: PlantingAreaEnum.LEASED, description: 'Arrendado' },
    { id: PlantingAreaEnum.OTHER, description: 'Outras Receitas' },
  ];

  public static DebtTypeEnums: Array<IdNumberAndDescription> = [
    { id: DebtTypeEnum.CONTRACT, description: 'Contrato' },
    { id: DebtTypeEnum.PERSONAL_COST, description: 'Custo Pessoal' },
    { id: DebtTypeEnum.PARCEL_YEARLY, description: 'Parcela anual' },
    { id: DebtTypeEnum.OTHER, description: 'Outros' },
  ];

  public static AnalysisStatusEnums: Array<IdNumberAndDescription> = [
    { id: AnalysisStatusEnum.OPEN, description: 'Aberto' },
    { id: AnalysisStatusEnum.ANALYZE, description: 'Em Análise' },
    { id: AnalysisStatusEnum.PASSED, description: 'Deferido' },
    { id: AnalysisStatusEnum.FAILED, description: 'Indeferido' },
    { id: AnalysisStatusEnum.CANCELED, description: 'Cancelado' },
  ];

  public static ActionStepEnums: Array<IdNumberAndDescription> = [
    { id: ActionStepEnum.DEFERRED, description: 'Deferido' },
    { id: ActionStepEnum.DEFERRED_HIGHER, description: 'Sob Judice' },
    {
      id: ActionStepEnum.DEFERRED_RESERVATION,
      description: 'Deferido com Ressalva',
    },
    { id: ActionStepEnum.REJECTED, description: 'Indeferido' },
    { id: ActionStepEnum.CANCELED, description: 'Cancelado' },
    { id: ActionStepEnum.ANALYZE, description: 'Em Análise' },
    { id: ActionStepEnum.REANALYZE, description: 'Reanalisar' },
  ];

  public static InfoInputValueEnums: Array<IdNumberAndDescription> = [
    { id: InfoInputValueEnum.AUTOMOBILE, description: 'Veículos' },
    { id: InfoInputValueEnum.MACHINE, description: 'Equipamento' },
    { id: InfoInputValueEnum.PROPERTY, description: 'Propriedade' },
    { id: InfoInputValueEnum.FINANCIAL, description: 'Financeiro' },
    { id: InfoInputValueEnum.CONSORTIUMS, description: 'Consórcios' },
    { id: InfoInputValueEnum.OTHER, description: 'Outros' },
  ];

  public static RatingEnum: Array<IdNumberAndDescription> = [
    { id: RatingEnum.C, description: 'C' },
    { id: RatingEnum.CP, description: 'C+' },
    { id: RatingEnum.CC, description: 'CC' },
    { id: RatingEnum.CCC, description: 'CCC' },
    { id: RatingEnum.B, description: 'B' },
    { id: RatingEnum.BP, description: 'B+' },
    { id: RatingEnum.BBB, description: 'BBB' },
    { id: RatingEnum.A, description: 'A' },
    { id: RatingEnum.AP, description: 'A+' },
    { id: RatingEnum.AA, description: 'AA' },
    { id: RatingEnum.AAA, description: 'AAA' },
  ];

  public static FiscalYearEnum: Array<IdNumberAndDescription> = [
    { id: FiscalYearEnum.CURRENT, description: 'Ano corrente'},
    { id: FiscalYearEnum.LAST, description: 'Ano anterior'},
    { id: FiscalYearEnum.CUSTOM, description: 'Personalizado'},
  ];

  public static AuditTypeEnum: Array<IdNumberAndDescription> = [
    { id: AuditTypeEnum.INSERCAO, description: 'Inserção' },
    { id: AuditTypeEnum.ATUALIZACAO, description: 'Atualização' },
    { id: AuditTypeEnum.DELECAO, description: 'Deleção' },
    { id: AuditTypeEnum.DOWNLOAD, description: 'Download' },
    { id: AuditTypeEnum.ACESSO, description: 'Acesso' },
    { id: AuditTypeEnum.LOGIN, description: 'Login' },

  ];

	public static TypeAnalyseEnum: Array<IdNumberAndDescription> = [
		{ id: TypeAnalyseEnum.WITH_CASHFLOW, description: 'Com fluxo de caixa' },
		{ id: TypeAnalyseEnum.NO_CASHFLOW, description: 'Dispensa de fluxo de caixa' },
    { id: TypeAnalyseEnum.CREDITO_ROTATIVO, description: 'Crédito rotativo pós vendas' },
	]

	public static TypeAnalyseCashflowEnum: Array<IdNumberAndDescription> = [
		{ id: TypeAnalyseEnum.WITH_CASHFLOW, description: 'Com fluxo de caixa' },
		{ id: TypeAnalyseEnum.NO_CASHFLOW, description: 'Dispensa de fluxo de caixa' },
	]

	public static TypeAnalyseRevolvingEnum: Array<IdNumberAndDescription> = [
		{ id: TypeAnalyseEnum.CREDITO_ROTATIVO, description: 'Crédito rotativo pós vendas' },
	]

  public static TypeDeliveryEnum: Array<IdNumberAndDescription> = [
    { id: TypeDeliveryEnum.NORMAL, description: 'Entrega normal' },
    { id: TypeDeliveryEnum.ANTICIPATED, description: 'Entrega antecipada' },
  ];

  public validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
        control.updateValueAndValidity();
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}

export interface IdNumberAndDescription {
  id: number;
  description: string;
}
